import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTriangle = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 8,
	height: 8,
	viewBox: "0 0 8 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#515d71",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1 2.5L4 5.5L7 2.5",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		vectorEffect: "non-scaling-stroke"
	})
});
export default SvgTriangle;
